<template>
  <el-dialog class="sk-qrcode-modal" width="90%" :close-on-click-modal="true" :visible.sync="visible">
    <a class="close-link" href="javascript:void(0)" @click="close">关闭</a>
    <div class="title">
      {{ context.sn }}收款码
    </div>
    <div style="font-weight:600;">
      订单金额：<span style="color:#FA2614">{{ context.amountPay | currencyFmt }}</span>
    </div>
    <div class="qr-code-sk" v-loading="loading">
      <div class="corner"></div>
      <div class="corner"></div>
      <div class="corner"></div>
      <div class="corner"></div>
      <img :src="qrCodeData" width="189" height="189" />
    </div>
    <div class="tip">
      支持 支付宝/微信 扫码支付
    </div>
    <div class="actions">
      <el-button type="primary" size="small" style="width: 205px; border-radius: 0;" @click="save" plain>保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import qrCodeCreator from '@/utils/qrcode-creator'
import fileDownload from '@/utils/file-download'
export default {
  mixins: [ModalMixin],
  data () {
    return {
      loading: false,
      context: {
        sn: undefined,
        qrCode: undefined
      },
      qrCodeData: ''
    }
  },
  computed: {
    zpcPayUrl () {
      return `https://zhaopeiyun.com/zpcpay?sn=${this.context.sn}&orderFrom=1`
    }
  },
  methods: {
    init (context) {
      if (context) {
        this.context = context
      }
      this.createQrImage()
      return this.open()
    },
    save () {
      fileDownload(this.qrCodeData, `${this.merchName}收款码.png`)
    },
    createQrImage () {
      this.loading = true
      qrCodeCreator(this.context.qrCode || this.zpcPayUrl).then((res) => {
        this.qrCodeData = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
